"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Yup = require("yup");
exports.default = Yup.object().shape({
    reason: Yup.string().required('Required'),
});
